import React from "react"
import Logotype from "../images/logotype.svg"

const Footer = ({ title, email, phone, instagram, facebook, content }) => {
  return (
    <footer className="footer">
      <div className="footer__container  u-wrap u-wrap--large">
        <div className="logo logo--footer">
          <img className="logo__image" src={Logotype} alt={title} />
        </div>
        <div className="footer__text footer__text--one">
          <p>
            {phone && (
              <span>
                <strong>Telefon:&nbsp;</strong>
                <a href={"tel:" + phone} className="footer__phone-number">
                  {phone}
                </a>
              </span>
            )}
            <br />
            {email && (
              <span>
                <strong>Email:&nbsp;</strong>
                <a href={"mailto:" + email} className="footer__email">
                  {email}
                </a>
              </span>
            )}
          </p>
        </div>
        {content && (
          <div
            className="footer__text footer__text--two"
            dangerouslySetInnerHTML={{
              __html: content.childMarkdownRemark.html,
            }}
          />
        )}
        <ul className="footer__some">
          {instagram && (
            <li className="footer__some-item">
              <a
                href={instagram}
                title="Följ oss på instagram"
                className="footer__some-instagram"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42">
                  <g fill="none">
                    <path
                      stroke="#fcffeb"
                      strokeWidth="2"
                      d="M41 21c0 11.0547667-8.9655172 20-20 20C9.96551724 41 1 32.0344828 1 21 1 9.96551724 9.96551724 1 21 1c11.0344828 0 20 8.94523327 20 20"
                    />
                    <path
                      fill="#fcffeb"
                      d="M21 24.8567493c-1.9283747 0-3.4894399-1.5610652-3.4894399-3.4894398 0-1.9283747 1.5610652-3.4894399 3.4894399-3.4894399 1.9283747 0 3.4894399 1.5610652 3.4894399 3.4894399 0 1.9283746-1.5610652 3.4894398-3.4894399 3.4894398m0-8.8705234c-2.9752066 0-5.3810836 2.4058769-5.3810836 5.3810836 0 2.9752066 2.405877 5.3810835 5.3810836 5.3810835 2.9752066 0 5.3810836-2.4058769 5.3810836-5.3810835 0-2.9752067-2.405877-5.3810836-5.3810836-5.3810836m6.8503214-.2203857c0 .697888-.5693297 1.2488522-1.2488522 1.2488522-.6978879 0-1.2488521-.5693297-1.2488521-1.2488522 0-.697888.5693296-1.2488521 1.2488521-1.2488521.697888 0 1.2488522.5509641 1.2488522 1.2488521"
                    />
                    <path
                      fill="#fcffeb"
                      d="M21 10.88062443c-2.8466483 0-3.1955923.01836547-4.3158861.05509641-1.1202939.05509642-1.8732783.22038566-2.5344353.49586776-.6795225.2754821-1.2672176.6244261-1.8549128 1.2121212-.5876951.5876952-.9366391 1.1753903-1.2121212 1.8549128-.25711659.661157-.44077132 1.4325069-.49586774 2.5344353-.05509642 1.1202938-.05509642 1.4692378-.05509642 4.3158861s.01836547 3.1955923.05509642 4.3158861c.05509642 1.1202939.22038567 1.8732783.49586774 2.5344353.2754821.6795225.6244261 1.2672176 1.2121212 1.8549127.5876952.5876952 1.1753903.9366392 1.8549128 1.2121213.661157.2571166 1.4325069.4407713 2.5344353.4958677 1.1202938.0550964 1.4692378.0550964 4.3158861.0550964s3.1955923-.0183654 4.3158861-.0550964c1.1202939-.0550964 1.8732783-.2203856 2.5344353-.4958677.6795225-.2754821 1.2672176-.6244261 1.8549128-1.2121213.5876951-.5876951.9366391-1.1753902 1.2121212-1.8549127.2571166-.661157.4407713-1.4325069.4958677-2.5344353.0550965-1.1202938.0550965-1.4692378.0550965-4.3158861s-.0183655-3.1955923-.0550965-4.3158861c-.0550964-1.1202939-.2203856-1.8732783-.4958677-2.5344353-.2754821-.6795225-.6244261-1.2672176-1.2121212-1.8549128-.5876952-.5876951-1.1753903-.9366391-1.8549128-1.2121212-.661157-.2571166-1.4325069-.44077134-2.5344353-.49586776-1.1019283-.03673094-1.4692378-.05509641-4.3158861-.05509641m0 1.89164367c2.7915519 0 3.1221304.0183655 4.2240588.0550965 1.0284665.0550964 1.5794306.2203856 1.9467401.3673094.4958678.1836547.8448118.4224059 1.2121212.7897153.3673095.3673095.5876951.7162535.7897153 1.2121213.1469238.3673094.3122131.9182736.3673095 1.9467401.0550964 1.1019284.0550964 1.4325069.0550964 4.2240588 0 2.7915518-.0183655 3.1221304-.0550964 4.2240587-.0550964 1.0284665-.2203857 1.5794307-.3673095 1.9467402-.1836547.4958677-.4224058.8448117-.7897153 1.2121212-.3673094.3673094-.7162534.5876951-1.2121212.7897153-.3673095.1469238-.9182736.312213-1.9467401.3673095-1.1019284.0550964-1.4325069.0550964-4.2240588.0550964s-3.1221304-.0183655-4.2240588-.0550964c-1.0284665-.0550965-1.5794306-.2203857-1.9467401-.3673095-.4958678-.1836547-.8448118-.4224059-1.2121212-.7897153-.3673095-.3673095-.5876951-.7162535-.7897153-1.2121212-.1469238-.3673095-.3122131-.9182737-.3673095-1.9467402-.0550964-1.1019283-.0550964-1.4325069-.0550964-4.2240587 0-2.7915519.0183655-3.1221304.0550964-4.2240588.0550964-1.0284665.2203857-1.5794307.3673095-1.9467401.1836547-.4958678.4224058-.8448118.7897153-1.2121213.3673094-.3673094.7162534-.5876951 1.2121212-.7897153.3673095-.1469238.9182736-.312213 1.9467401-.3673094 1.1019284-.036731 1.4325069-.0550965 4.2240588-.0550965"
                    />
                  </g>
                </svg>
                <span className="u-sr">Följ oss på instagram</span>
              </a>
            </li>
          )}
          {facebook && (
            <li className="footer__some-item">
              <a
                href={facebook}
                title="Följ oss på Facebook"
                className="footer__some-facebook"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42">
                  <g fill="none">
                    <path
                      stroke="#fcffeb"
                      strokeWidth="2"
                      d="M40.9191919 20.979798c0 11.010101-8.9292929 19.9191919-19.9191919 19.9191919-10.98989899 0-19.91919192-8.9292929-19.91919192-19.9191919C1.08080808 9.98989899 10.01010101 1.06060606 21 1.06060606c10.989899 0 19.9191919 8.90909091 19.9191919 19.91919194"
                    />
                    <path
                      fill="#fcffeb"
                      d="M26.1717172 9.46464646v3.75757574c0 .1616162-.0404041.2020202-.2020202.2020202h-1.939394c-.2222222 0-.4444444.0404041-.6464646.0808081-.4040404.0808081-.7070707.4242424-.7272727.8888889-.0202021.8282828-.0202021 1.6565657-.0404041 2.4848485 0 .1616161.1010101.1212121.1818182.1212121h3.3939394c-.1414141 1.3333333-.2828283 2.6464646-.4242424 3.959596h-3.1515152v11.5151515h-4.3232323V20.959596h-2.8686869v-3.7777778c0-.1616162.0404041-.2222222.2222222-.2222222h2.4646465c.1616162 0 .2020202-.0404041.2020202-.2020202 0-.8686869-.020202-1.7373738 0-2.6060606.020202-.8484849.1010101-1.6969697.4242424-2.4848485.3636364-.94949498 1.0303031-1.59595963 1.979798-1.89898993.4444445-.14141414.9292929-.2020202 1.3939394-.30303031.0606061-.02020202.1212121-.02020202.2020202-.04040404 1.2727273.04040404 2.5656566.04040404 3.8585859.04040404z"
                    />
                  </g>
                </svg>
                <span className="u-sr">Följ oss på Facebook</span>
              </a>
            </li>
          )}
        </ul>
      </div>
    </footer>
  )
}
export default Footer
